import { connect } from 'react-redux';
import Practice from '../../components/practice/Practice';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Practice);
